import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Precarga en segundo plano solo las rutas marcadas con `data: { preload: true }`.
 *
 * Sin esto, cada pantalla del portal descarga su chunk recién cuando alguien
 * la abre: por eso el primer salto a Cuenta, Inicio u Orden se sentía lento,
 * aunque los datos ya estuvieran. Precargando después del arranque, el salto
 * es instantáneo.
 *
 * No se usa `PreloadAllModules` a propósito: los visores DICOM y 3D pesan
 * varios MB (three.js, Babylon, el parser DICOM) y bajarlos sin que nadie los
 * haya pedido castiga los datos móviles del doctor. Esos quedan bajo demanda.
 */
@Injectable({ providedIn: 'root' })
export class PreloadPortalStrategy implements PreloadingStrategy {
  preload(route: Route, cargar: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] ? cargar() : of(null);
  }
}
